var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ic_ruler_svg__a,.ic_ruler_svg__b{fill:none}.ic_ruler_svg__b{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ic_ruler_svg__a",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ic_ruler_svg__a",
    d: "M0 0h24v24H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ic_ruler_svg__b",
    d: "M14.475 4.581a3.5 3.5 0 11-4.95 0 3.5 3.5 0 014.95 0M4 18.556v1a1 1 0 001 1h14a1 1 0 001-1v-1c0-3.026-3.952-4.992-8-4.992s-8 1.966-8 4.992z"
  })));
}
export default SvgIcRuler;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/ic_ruler.svg
// module id = 7802
// module chunks = 11